import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m35.722 5.187-6.218 6.218h14.008a.988.988 0 0 1 0 1.976H29.503l6.219 6.218a.988.988 0 0 1-1.398 1.397l-7.905-7.905a.988.988 0 0 1 0-1.397l7.905-7.905a.988.988 0 0 1 1.398 1.398Zm-8.764 39.72c2.67.303 5.217-.135 7.358-1.303.924-.504 1.778-1.16 2.6-1.987 1.144-1.152 1.751-1.836 2.386-2.706l.078-.09c.793-.917 1.102-1.504 1.164-2.399.101-1.401-.52-2.476-1.98-3.83-.862-.8-1.884-1.476-3.132-2.087a55.626 55.626 0 0 0-.74-.36c-.912-.434-1.609-.695-2.313-.851-1.399-.31-2.645-.13-3.685.61-.41.291-.707.58-1.227 1.171l-.116.132c-.13.148-.21.236-.286.316-.576.6-1.119 1.03-1.672 1.325-2.725 1.452-6.542.856-8.903-1.394-1.326-1.392-2.138-3.483-2.09-5.45.038-1.602.568-3.162 1.486-4.38.254-.336.498-.607 1.17-1.292l.343-.352c.881-.916 1.319-1.941 1.31-3.146-.007-1.022-.224-1.79-.88-3.298l-.065-.151-.063-.146c-.57-1.32-1.037-2.188-1.63-2.992-.918-1.243-1.847-2.07-2.916-2.516-.76-.316-1.57-.369-2.328-.131-.598.187-.98.436-1.686 1.05-.13.113-.13.113-.2.17-2.533 1.94-4.036 3.623-4.946 5.673-1.492 3.363-1.282 7.362.46 11.675 1.49 3.683 3.967 7.235 7.14 10.283 1.689 1.764 3.708 3.417 5.893 4.821 3.166 2.037 6.367 3.282 9.47 3.635Z",
    fill: "currentColor"
  }));
};

var SvgCallback = styled(SvgComponent).withConfig({
  displayName: "Callback__SvgCallback",
  componentId: "sc-wrvaln-0"
})(["", " ", ""], size, color);
export default SvgCallback;